import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b20dc42"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-arrow-left",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = {
  key: 0,
  style: {"margin-top":"-1.75rem"}
}
const _hoisted_3 = {
  class: "text-danger col-12",
  style: {"font-size":"1.25rem"}
}
const _hoisted_4 = {
  key: 0,
  class: "d-block"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "*", -1))
const _hoisted_6 = {
  key: 1,
  class: "d-block"
}
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "col-md-6 col-xl-4" }
const _hoisted_9 = {
  for: "form-store-put-cnpj",
  class: "form-label cor_texto_1"
}
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = { class: "col-md-6 col-xl-4" }
const _hoisted_13 = {
  for: "form-store-put-nome-corporativo",
  class: "form-label cor_texto_1"
}
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = { class: "col-md-6 col-xl-4" }
const _hoisted_16 = {
  for: "form-store-put-nome-fantasia",
  class: "form-label cor_texto_1"
}
const _hoisted_17 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_18 = { class: "col-md-6 col-xl-4" }
const _hoisted_19 = {
  for: "form-store-put-uf",
  class: "form-label cor_texto_1"
}
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { class: "col-md-6 col-xl-4" }
const _hoisted_22 = {
  for: "form-store-put-city",
  class: "form-label cor_texto_1"
}
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "col-md-6 col-xl-4" }
const _hoisted_25 = {
  for: "form-store-put-cep",
  class: "form-label cor_texto_1"
}
const _hoisted_26 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_27 = { class: "col-md-6 col-xl-4" }
const _hoisted_28 = {
  for: "form-store-put-street",
  class: "form-label cor_texto_1"
}
const _hoisted_29 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_30 = { class: "col-md-6 custom-col" }
const _hoisted_31 = {
  for: "form-store-put-number",
  class: "form-label cor_texto_1"
}
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-md-6 col-xl-4" }
const _hoisted_34 = {
  for: "form-store-put-neighborhood",
  class: "form-label cor_texto_1"
}
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = { class: "col-md-6 col-xl-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-store-put-code-regional-internal-salesman",
  class: "form-label cor_texto_1"
}, "Cód. Vendedor Regional Interno: ", -1))
const _hoisted_38 = { class: "col-md-6 col-xl-4" }
const _hoisted_39 = {
  for: "form-store-put-responsavel",
  class: "form-label cor_texto_1"
}
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = { class: "col-md-6 col-xl-4" }
const _hoisted_42 = {
  for: "form-store-put-e-mail",
  class: "form-label cor_texto_1"
}
const _hoisted_43 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = { class: "col-md-6 col-xl-4" }
const _hoisted_46 = {
  for: "form-store-put-telefone",
  class: "form-label cor_texto_1"
}
const _hoisted_47 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_48 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_49 = { class: "col-md-6 col-xl-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-store-put-consultant",
  class: "form-label cor_texto_1"
}, "Consultor:", -1))
const _hoisted_51 = { class: "row g-4" }
const _hoisted_52 = { class: "row g-4" }
const _hoisted_53 = {
  for: "form-store-post-moderator",
  class: "form-label cor_texto_1"
}
const _hoisted_54 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_55 = {
  key: 0,
  class: "col-sm-6 col-md-4 col-xl-6 col-xxl-4"
}
const _hoisted_56 = {
  for: "form-store-post-moderator",
  class: "form-label cor_texto_1"
}
const _hoisted_57 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_58 = { class: "d-flex align-items-center gap-4 px-3 py-1 put-page-input-switch" }
const _hoisted_59 = {
  key: 0,
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_60 = {
  key: 1,
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_61 = { class: "col-sm-6 col-md-4 col-xl-6 col-xxl-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-store-post-moderator",
  class: "form-label cor_texto_1"
}, "Login por Pdv: ", -1))
const _hoisted_63 = { class: "d-flex align-items-center gap-4 px-3 py-1 put-page-input-switch" }
const _hoisted_64 = {
  key: 0,
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_65 = {
  key: 1,
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-store-put-profile",
  class: "form-label cor_texto_1"
}, "Perfil:", -1))
const _hoisted_67 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  width: "16",
  height: "16",
  style: {"margin-left":"8px"}
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-80c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_71 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form-store-put-percent_value",
  class: "form-label cor_texto_1"
}, "Porcentagem Moderador:", -1))
const _hoisted_73 = {
  for: "form-store-put-percent_value",
  class: "form-label cor_texto_1"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"padding":"0px 4px","border-radius":"50%","border":"1px solid black","font-size":"9px !important"},
  class: "fw-bolder cor_texto_1"
}, "?", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-0 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn background_btn_1",
    style: {"color":"var(--cor_icones_1)"}
  }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "fa fa-save",
      style: {"color":"var(--cor_icones_1)"},
      "aria-hidden": "true"
    }),
    /*#__PURE__*/_createTextVNode(" Salvar ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampHeader = _resolveComponent("CampHeader")!
  const _component_CampFormHeader = _resolveComponent("CampFormHeader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CampHeader, null, {
      title: _withCtx(() => [
        _createTextVNode("Editar Loja")
      ]),
      button: _withCtx(() => [
        _createVNode(_component_router_link, {
          to: `/lojas`,
          class: "btn btn_background_1"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" Voltar ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    ( _ctx.queryObject.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            class: "row g-4 px-2",
            id: "form-store-put",
            onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitForm && _ctx.onSubmitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.isRequiredField)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createTextVNode(" Campos obrigatórios "),
                    _hoisted_5
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isInvalidFieldWarning)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Verifique também se são informações válidas. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("fieldset", {
              class: "background_1 card p-4",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearWarning && _ctx.clearWarning(...args)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_CampFormHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode("1. Dados gerais")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, [
                    _createTextVNode("CNPJ: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_10, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.cnpj,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryObject.data.cnpj) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-cnpj",
                    id: "form-store-put-cnpj",
                    class: "disabled-input",
                    "input-style": "color: var(--cor_texto_1) !important;",
                    disabled: "true"
                  }, null, 8, ["modelValue"]), [
                    [_directive_maska, {mask:'##.###.###/####-##'}]
                  ]),
                  (_ctx.isInvalidField.cnpj)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Informe um CNPJ válido "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _createTextVNode("Nome Corporativo: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_14, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.corporate_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryObject.data.corporate_name) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-nome-corporativo",
                    id: "form-store-put-nome-corporativo"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, [
                    _createTextVNode("Nome Fantasia: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_17, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.fantasy_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.queryObject.data.fantasy_name) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-nome-fantasia",
                    id: "form-store-put-nome-fantasia"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, [
                    _createTextVNode("Estado (UF): "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_20, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_select, {
                    id: "form-store-put-uf",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    placeholder: "Selecione um estado...",
                    style: {"margin-top":"0","width":"100%"},
                    modelValue: _ctx.queryObject.data.uf,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.queryObject.data.uf) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.UF_LIST, (el) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: el.key,
                          value: el.key,
                          label: el.label
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _createTextVNode("Cidade: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_23, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.city,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.queryObject.data.city) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-city",
                    id: "form-store-put-city"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _createTextVNode("CEP: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_26, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.cep,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.queryObject.data.cep) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-cep",
                    id: "form-store-put-cep"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, [
                    _createTextVNode("Rua: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_29, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.street,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.queryObject.data.street) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-street",
                    id: "form-store-put-street"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, [
                    _createTextVNode("Número: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_32, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.number,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.queryObject.data.number) = $event)),
                    clearable: "",
                    type: "number",
                    name: "form-store-put-number",
                    id: "form-store-put-number"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, [
                    _createTextVNode("Bairro: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_35, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.neighborhood,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.queryObject.data.neighborhood) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-neighborhood",
                    id: "form-store-put-neighborhood"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.code_regional_internal_salesman,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.queryObject.data.code_regional_internal_salesman) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-code-regional-internal-salesman",
                    id: "form-store-put-code-regional-internal-salesman"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, [
                    _createTextVNode("Responsável: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_40, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.responsible,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.queryObject.data.responsible) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-responsavel",
                    id: "form-store-put-responsavel"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, [
                    _createTextVNode("E-mail: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_43, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.email,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.queryObject.data.email) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-e-mail",
                    id: "form-store-put-e-mail"
                  }, null, 8, ["modelValue"]),
                  (_ctx.isInvalidField.mail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, " Informe um e-mail válido "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, [
                    _createTextVNode("Telefone: "),
                    (_ctx.isRequiredField)
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_47, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: _ctx.queryObject.data.telephone,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.queryObject.data.telephone) = $event)),
                    clearable: "",
                    type: "text",
                    name: "form-store-put-telefone",
                    id: "form-store-put-telefone"
                  }, null, 8, ["modelValue"]), [
                    [_directive_maska, { mask:`${(_ctx.queryObject.data.telephone.replace(/[^\d]+/g, '').length < 13) ? '+55 (##) ####-####' : '+55 (##) # ####-####'}` }]
                  ]),
                  (_ctx.isInvalidField.phoneNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Informe um telefone válido "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_el_select, {
                    id: "form-store-put-consultant",
                    filterable: "",
                    clearable: "",
                    placeholder: "Selecione um consultor...",
                    style: {"margin-top":"0","width":"100%"},
                    modelValue: _ctx.queryObject.data.id_consultant,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.queryObject.data.id_consultant) = $event)),
                    "no-data-text": 'Nenhum consultor cadastrado'
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consultantField, (el) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: el.id,
                          value: el.id,
                          label: el.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("fieldset", {
              class: "background_1 card p-4",
              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.clearWarning && _ctx.clearWarning(...args)))
            }, [
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_CampFormHeader, null, {
                  default: _withCtx(() => [
                    _createTextVNode("2. Configurações")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.queryObject.data.sale_status_default === 1 ? 'col-xl-6' : 'col-md-4')
                }, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.queryObject.data.sale_status_default === 1 ? 'col-sm-6 col-md-8 col-xl-6 col-xxl-8' : 'col-md-12')
                    }, [
                      _createElementVNode("label", _hoisted_53, [
                        _createTextVNode("Aprovar vendas: "),
                        (_ctx.isRequiredField)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_54, "*"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_el_select, {
                        onClick: _ctx.clearWarning,
                        id: "form-store-post-moderator",
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        "reserve-keyword": false,
                        placeholder: "Selecione um perfil...",
                        style: {"margin-top":"0","width":"100%"},
                        modelValue: _ctx.queryObject.data.sale_status_default,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.queryObject.data.sale_status_default) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalOptions, (el) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: el.id,
                              value: el.id,
                              label: el.name
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onClick", "modelValue"])
                    ], 2),
                    (_ctx.queryObject.data.sale_status_default === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("label", _hoisted_56, [
                            _createTextVNode("Moderador: "),
                            (_ctx.isRequiredField)
                              ? (_openBlock(), _createElementBlock("strong", _hoisted_57, "*"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createVNode(_component_el_switch, {
                              size: "small",
                              id: "form-training-post-active",
                              modelValue: _ctx.queryObject.data.reward_the_moderator,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.queryObject.data.reward_the_moderator) = $event)),
                              style: {"--el-switch-on-color":"var(--el-color-primary)"}
                            }, null, 8, ["modelValue"]),
                            (_ctx.queryObject.data.reward_the_moderator)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Ganhar por aprovação"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_60, "Não ganhar por aprovação"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_el_switch, {
                          size: "small",
                          id: "form-training-post-active",
                          modelValue: _ctx.queryObject.data.login_pdv,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.queryObject.data.login_pdv) = $event)),
                          style: {"--el-switch-on-color":"var(--el-color-primary)"}
                        }, null, 8, ["modelValue"]),
                        (_ctx.queryObject.data.login_pdv)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Sim"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_65, "Não"))
                      ])
                    ])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.queryObject.data.sale_status_default === 1 ? 'col-xl-3' : 'col-md-4')
                }, [
                  _hoisted_66,
                  _createVNode(_component_el_tooltip, {
                    class: "item",
                    effect: "dark",
                    placement: "bottom"
                  }, {
                    content: _withCtx(() => [
                      _createTextVNode(" Caso a a loja seja PDV sera selecionado automaticamente. ")
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("svg", _hoisted_67, _hoisted_69))
                    ]),
                    _: 1
                  }),
                  (_ctx.isRequiredField)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_70, "*"))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_select, {
                    id: "form-store-put-profile",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    placeholder: "Selecione um perfil...",
                    style: {"margin-top":"0","width":"100%"},
                    modelValue: _ctx.queryObject.data.id_profile,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.queryObject.data.id_profile) = $event)),
                    disabled: _ctx.queryObject.data.login_pdv
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileField, (el) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: el.id,
                          value: el.id,
                          label: el.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ], 2),
                (_ctx.IS_PERCENTAGE_POINT_STORE_MODERATOR)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _hoisted_72,
                      _withDirectives(_createVNode(_component_el_input, {
                        id: "form-store-put-percent_value",
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        "reserve-keyword": false,
                        placeholder: "Selecione uma porcentagem...",
                        style: {"margin-top":"0","width":"100%"},
                        modelValue: _ctx.queryObject.data.percent_value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.queryObject.data.percent_value) = $event))
                      }, null, 8, ["modelValue"]), [
                        [_directive_maska, {mask:'##%'}]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.queryObject.data.sale_status_default === 1 ? 'col-xl-3' : 'col-md-4')
                }, [
                  _createElementVNode("label", _hoisted_73, [
                    _createTextVNode("Grupo: "),
                    (_ctx.isMainCNPJGroup)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          class: "item",
                          effect: "dark",
                          placement: "bottom"
                        }, {
                          content: _withCtx(() => [
                            _createTextVNode(" Essa loja está vinculada ao CNPJ RAIZ de um grupo. É necessário excluir o ou alterar o CNPJ RAIZ do grupo para tirar o vinculo. ")
                          ]),
                          default: _withCtx(() => [
                            _hoisted_74
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_select, {
                    id: "form-store-put-Group",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    placeholder: "Selecione um grupo...",
                    style: {"margin-top":"0","width":"100%"},
                    modelValue: _ctx.queryObject.data.id_group,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.queryObject.data.id_group) = $event)),
                    "no-data-text": 'A companhia não possui grupos cadastrados',
                    disabled: _ctx.isMainCNPJGroup
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupField, (el) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: el.id,
                          value: el.id,
                          label: el.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ], 2)
              ])
            ]),
            _hoisted_75
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}